import { css } from '@emotion/react';
import { COLORS } from '@tablekit/theme';
import { resolveColor } from './shared.js';

var outlineVariant = function outlineVariant(props) {
  return /*#__PURE__*/css("&,&:focus{color:", resolveColor('main', props), ";border-color:", resolveColor('main', props), ";background:transparent;}&:hover,&:hover:focus{background:", resolveColor('hoverTransparent', props), ";}&:active,&:active:focus{background:", resolveColor('activeTransparent', props), ";box-shadow:0 0 4px 0 ", COLORS.GRAY_TRANSLUCENT.L2, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:outlineVariant;"));
};

export { outlineVariant };
